import React from 'react'
import { resolveComponentForOperator } from 'components/ContactFilterBuilder/constants/PropertyComponents'

const Is = ({ property, onChange, value }) => {  

  const PropertyComponent = resolveComponentForOperator(property.type, 'IS')

  return (
    <div>
      <PropertyComponent
        property={property}
        onChange={onChange}
        value={value}
        isOperator={true}
      />
    </div>
  )
}

export default Is
